module.exports = __webpack_public_path__ + "static/media/Deep Horizon.351e49ef.jpg";